import {
  TextInput,
  TextInputProps,
  StyleProp,
  TextStyle,
} from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import { useTheme } from '@/lib/styling';
import { Theme } from '@/theme';

interface TextareaProps extends Omit<TextInputProps, 'multiline'> {
  className?: string; // Compatibility
  rows?: number;
  style?: StyleProp<TextStyle>;
}

export function Textarea({
  style,
  rows = 4,
  ...props
}: TextareaProps) {
  const theme = useTheme<Theme>();
  const minHeight = Math.max(80, rows * 20);
  const maxHeight = Math.max(160, minHeight * 2);

  return (
    <TextInput
      {...props}
      style={[
        styles.textarea,
        { height: minHeight, minHeight, maxHeight },
        style
      ]}
      multiline
      numberOfLines={rows}
      scrollEnabled
      textAlignVertical="top"
      placeholderTextColor={theme.colors.pressMuted}
    />
  );
}

const styles = StyleSheet.create((theme) => ({
  textarea: {
    backgroundColor: theme.colors.surface,
    borderColor: theme.colors.border,
    borderRadius: theme.borderRadii.m,
    borderWidth: 1,
    color: theme.colors.text,
    elevation: 0,
    fontFamily: theme.typography.fontFamily.body,
    fontSize: 15,
    paddingHorizontal: theme.spacing.m,
    paddingVertical: theme.spacing.s,
    shadowColor: 'transparent',
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0,
    shadowRadius: 0,
    textAlignVertical: 'top',
    width: '100%',
  },
}));
